import React from "react";
import LoginSignUp from "./LoginSignUp";

const SignUp = () => {
  return <LoginSignUp />;
};

export default SignUp;
